import { render, staticRenderFns } from "./BaseInfoPanel.vue?vue&type=template&id=1ae20660&scoped=true"
import script from "./BaseInfoPanel.vue?vue&type=script&lang=ts"
export * from "./BaseInfoPanel.vue?vue&type=script&lang=ts"
import style0 from "./BaseInfoPanel.vue?vue&type=style&index=0&id=1ae20660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae20660",
  null
  
)

export default component.exports